import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { DeFiRow } from "./type";
import { DefiFeaturedItem } from "./DefiItem";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 980 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 980, min: 768 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const FeaturedDefi = ({ featuredData }: { featuredData: DeFiRow[] }) => {
  if (featuredData.length === 0) {
    return null;
  }
  return (
    <>
      <Flex alignItems={"center"} gap={2} p={{ base: "0px 12px", lg: 0 }}>
        <Text
          fontSize={{ base: "16px" }}
          fontWeight="600"
          color="textPrimary"
          marginBottom={{
            base: 0,
          }}
        >
          Top Opportunities
        </Text>
      </Flex>
      <Carousel
        responsive={responsive}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        itemClass=""
        customLeftArrow={
          <button
            style={{
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
            className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
          >
            <FiChevronLeft />
          </button>
        }
        customRightArrow={
          <button
            style={{
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
            className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
          >
            <FiChevronRight />
          </button>
        }
      >
        {featuredData.map((item: DeFiRow, idx: number) => (
          <Flex
            key={`featured_${idx}`}
            width={{ base: "100%", sm: "100%", md: "97%" }}
          >
            <DefiFeaturedItem row={item} />
          </Flex>
        ))}
      </Carousel>
    </>
  );
};

export default FeaturedDefi;
